// extracted by mini-css-extract-plugin
export default {"base":"IRu1b","color":"lb97b"};